export default "__VITE_ASSET__CY7VoZKM__$_?component__"